<div class="overlay">
  <div class="dialog" *ngIf="claimData">
    <div class="dialog-title">
      <h5>Timely Filing Report</h5>
      <button type="button" (click)="close()">&#10006;</button>
    </div>
    <div class="form-section">
      <img src="./assets/img/logo.png" />
      <div>
        <div class="timely-filing-report">
          <p>
            <span>Date: </span> <strong>{{ currentDate }}</strong>
          </p>
          <p>
            <span>Payer Name: </span>
            <strong>{{
              claimData.insurance ? claimData.insurance : 'N/A'
            }}</strong>
          </p>
          <p>
            <span>Proof of Timely Filing by: </span>
            <strong>{{
              claimData.providerGroupName ? claimData.providerGroupName : 'N/A'
            }}</strong>
          </p>
          <p>
            Our records show that the claim identified below was transmitted to
            you electronically on
            <strong>{{
              carrierProcessDate
                ? carrierProcessDate.substr(4, 2) +
                  '/' +
                  carrierProcessDate.substr(6, 2) +
                  '/' +
                  carrierProcessDate.substr(0, 4)
                : 'N/A'
            }}</strong>
            We request that this information be reviewed to verify its timely
            filing:
          </p>
          <p>
            <span>Secure Connect Claim ID: </span>
            <strong>{{ claimData.claimId ? claimData.claimId : 'N/A' }}</strong>
          </p>
          <p>
            <span>Payer Claim Control Number: </span>
            <strong>{{
              claimData.payerTraceNumber ? claimData.payerTraceNumber : 'N/A'
            }}</strong>
          </p>
          <p>
            <span>Billing Provider Tax ID: </span>
            <strong>{{ billingTaxId ? billingTaxId : 'N/A' }}</strong>
          </p>
          <p>
            <span>Billing Provider NPI: </span>
            <strong>{{ billingNpi ? billingNpi : 'N/A' }}</strong>
          </p>
          <p>
            <span>Rendering Provider NPI: </span>
            <strong>{{ renderingNpi ? renderingNpi : 'N/A' }}</strong>
          </p>
          <p>
            <span>Billing Provider Name: </span>
            <strong>{{
              billingProviderFirstname ? billingProviderFirstname : 'N/A'
            }}</strong>
          </p>
          <p>
            <span>Patient Name: </span>
            <strong>{{
              claimData.patientName ? claimData.patientName : 'N/A'
            }}</strong>
          </p>
          <p>
            <span>Insured ID: </span>
            <strong>{{
              claimData.insuredId ? claimData.insuredId : 'N/A'
            }}</strong>
          </p>
          <p>
            <span>Patient Control Number: </span>
            <strong>{{
              claimData.patientAccountNumber
                ? claimData.patientAccountNumber
                : 'N/A'
            }}</strong>
          </p>
          <p>
            <span>Dates of Service: </span>
            <strong>{{
              claimData.dateOfService
                ? (claimData.dateOfService | date: 'MM/dd/yyyy')
                : 'N/A'
            }}</strong>
          </p>
          <p>
            <span>Payer ID: </span>
            <strong>{{ claimData.payerId ? claimData.payerId : 'N/A' }}</strong>
          </p>
          <p>
            <span>Payer Name: </span>
            <strong>{{
              claimData.insurance ? claimData.insurance : 'N/A'
            }}</strong>
          </p>
          <p>
            <span>Total Amount Billed: </span>
            <strong>{{
              claimData.totalCharges
                ? (claimData.totalCharges
                  | currency: 'USD' : 'symbol' : '1.2-2')
                : 'N/A'
            }}</strong>
          </p>
          <p>
            We kindly request this claim be processed for services rendered to
            the member patient.
          </p>
          <p>Thank you.</p>
          <p>
            <span>Billing Representative</span>
          </p>
        </div>
      </div>
    </div>
    <div class="dialog-footer">
      <div class="footer-section">
        <a href="javascript:void(0);" (click)="printReceipt()">
          <h5>Print Report</h5>
        </a>
      </div>
    </div>
  </div>
</div>
